import React, { useEffect } from "react";
import { getAllRadiologyReport } from "../../../../store/slices/radiologyReport";
import { useDispatch, useSelector } from "react-redux";
import styles from "../editMedicalCertificate.module.scss";
import classNames from "classnames";
import { getAllClinic } from "../../../../store/slices/clinicSlice";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const Remark = ({
  medicalCertificate,
  handleAddDescription,
  medicalCertificateFormData,
}) => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const radiologyReportId = sessionStorage.getItem("radiologyReportId");
  const { token } = useSelector((state) => state.auth);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getAllRadiologyReport({ clinicId, reportId: radiologyReportId, token }),
    );
    dispatch(getAllClinic({ token }));
  }, [dispatch, clinicId, radiologyReportId, token]);
  return (
    <div className={classNames(styles.testAndProfile, "card")}>
      <div className="card-body pt-0">
        <div className="row mt-5">
          <div className="col-md-12">
            <h5 className="mb-4 mt-2">Abnormal Finding :</h5>
            <div className={styles["ckEditor"]}>
              <CKEditor
                editor={ClassicEditor}
                data={medicalCertificateFormData?.abnormalFinding || ""}
                onChange={(event, editor) =>
                  handleAddDescription(editor, "abnormalFinding")
                }
              />
            </div>
          </div>
          <div className="col-md-12">
            <h5 className="mb-4 mt-5">Remark :</h5>
            <div className={styles["ckEditor"]}>
              <CKEditor
                editor={ClassicEditor}
                data={medicalCertificateFormData?.remark || ""}
                onChange={(event, editor) =>
                  handleAddDescription(editor, "remark")
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Remark;
